import React, { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import DashboardShell from "../../components/layout/DashboardShell";
import { Button, Card } from "../../components/common/Primitives";
import SessionDevicesCard from "../../components/common/SessionDevicesCard";
import MotionPreferenceCard from "../../components/common/MotionPreferenceCard";
import { useAuth } from "../../lib/AuthContext";
import api, { formatApiError } from "../../lib/api";

export default function StartupSettings() {
  const { user, logout } = useAuth();
  const [optOut, setOptOut] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setOptOut(!!data.digest_opt_out)).catch(() => {});
  }, []);

  const toggleDigest = async (next) => {
    setBusy(true);
    try {
      await api.post("/users/me/digest-opt-out", { digest_opt_out: next });
      setOptOut(next);
      toast.success(next ? "Daily digest emails paused." : "Daily digest emails resumed.");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <DashboardShell title="Settings" subtitle="STARTUP · ACCOUNT">
      <Toaster richColors position="top-right" />
      <div className="grid gap-4 max-w-xl">
        <Card>
          <div className="overline mb-3">Account</div>
          <div className="text-sm text-ink-soft">Signed in as</div>
          <div className="font-heading text-ink text-lg mt-1">{user?.email}</div>
          <div className="mt-6 flex gap-3">
            <Button onClick={() => toast.info("Password reset flow — coming soon in this MVP.")} variant="ghost" data-testid="settings-reset-password">Reset Password</Button>
            <Button onClick={logout} variant="danger" data-testid="settings-signout">Sign Out</Button>
          </div>
        </Card>
        <Card>
          <div className="overline mb-3">Email Preferences</div>
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="text-ink font-heading">Daily unread digest</div>
              <div className="text-xs text-ink-muted mt-1">
                A once-a-day summary of investor interest, deal-room activity, and unread messages.
              </div>
            </div>
            <label className="inline-flex items-center gap-2 cursor-pointer" data-testid="startup-digest-toggle">
              <input
                type="checkbox"
                checked={!optOut}
                disabled={busy}
                onChange={(e) => toggleDigest(!e.target.checked)}
                className="w-4 h-4"
              />
              <span className="text-xs font-mono text-ink-muted">{!optOut ? "ON" : "OFF"}</span>
            </label>
          </div>
        </Card>
        <MotionPreferenceCard />
        <SessionDevicesCard />
      </div>
    </DashboardShell>
  );
}
